import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ROUTES } from '../constants';
import { useAuth } from '../hooks/useAuth';
import LoaderComponent from '@/components/LoaderComponent';

interface PermissionRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

export default function PermissionRoute({
  children,
  requiredPermission,
}: PermissionRouteProps): React.JSX.Element {
  const { authed } = useAuth();
  const location = useLocation();

  const permissionState = useSelector(({ getUserPermission }: any) => getUserPermission);

  // 1️⃣ If not authenticated
  if (!authed) {
    return <Navigate to={ROUTES.LoginPage} replace state={{ path: location.pathname }} />;
  }

  // 2️⃣ WAIT until permission API response comes
  if (!permissionState || permissionState.loading) {
    return <LoaderComponent />; // or return <Loader />
  }

  const userRoles = permissionState?.userRoles?.data;

  // 3️⃣ If no permission required
  if (!requiredPermission) {
    return <>{children}</>;
  }

  // 4️⃣ Check permission safely
  const hasPermission = userRoles?.permission?.[requiredPermission] === true;

  if (!hasPermission) {
    return <Navigate to={ROUTES.Error403} replace />;
  }

  return <>{children}</>;
}
